import { AxisBottom } from '@visx/axis';
import type { ScaleTime } from 'd3-scale';
import type { D3Scale } from '@visx/scale';
import { useTheme } from '@simplywallst/ui-core';

interface Props {
  left: number;
  top: number;
  xScale: ScaleTime<number, number>;
  numTicks: number;
}

export const BottomAxis = ({ xScale, top, numTicks, left }: Props) => {
  const theme = useTheme();
  return (
    <g pointerEvents="none">
      <AxisBottom
        left={left}
        top={top}
        scale={xScale as D3Scale<number, number>}
        numTicks={numTicks}
      >
        {({ ticks, axisToPoint }) => {
          return (
            <g>
              <rect
                width={axisToPoint.x > 0 ? axisToPoint.x : 0}
                height={1}
                y={0}
                fill={theme.color.whiteRGBA(0.5)}
              />
              {ticks.map((d, i) => (
                <g
                  key={`bottom-axis-${i}-${d.formattedValue}`}
                  transform={`translate(${d.to.x}, 0)`}
                >
                  <rect
                    fill={theme.color.whiteRGBA(0.5)}
                    width="1"
                    height="6"
                  />
                  <text
                    y="20"
                    fontSize="12"
                    textAnchor="middle"
                    fill={theme.color.white}
                  >
                    {d.formattedValue}
                  </text>
                </g>
              ))}
            </g>
          );
        }}
      </AxisBottom>
    </g>
  );
};
